<template>
    <div class="step-detail step-four">
        <h1 class="line-bottom">{{ $t('4. Resultaat van uw configuratie')}}</h1>
        <div style="position:absolute;
left:0;
right:0;
margin-left:auto;
margin-right:auto;
text-align: center;
z-index: 100;" v-if="isLoading">
            <img width="100px" src="../assets/icons/loading.gif" />
        </div>

        <div class="row">
            <p class="col-md-3 col-lg-4">
                {{ $t('Hieronder vindt u de lijst en kostprijs van uw configuratie. Klik op de knop “Download documenten” om een pakket of selectie te downloaden. Klik op export om uw configuratie als .xls of .pdf document te downloaden.')}}
            </p>

            <div class="col-md-9  col-lg-8 export">
                <div class="export-inner">
                    <button class="btn default icon download px-2" >
                        {{ $t('Download documenten') }}
                    </button>

                    <!--<router-link to="/excelexport">-->
                    <button class="btn default icon excel px-2" @click="sendExcelData()">
                        {{ $t('Exporteer als Excel') }}
                    </button>

                    <!--                    </router-link>-->
                    <button class="btn default icon pdf px-2" @click="sendPdfData()">
                        {{ $t('Exporteer als Pdf') }}
                    </button>

                    <!-- @click="sendAsOrder()"-->
                    <b-button class="btn default icon send px-2" @click="showForm()">
                        {{ $t('Verzenden als bestelling') }}
                    </b-button>
                    <button class="btn default icon remove px-2" @click="deleteEverything()">
                        {{ $t('Alles verwijderen') }}
                    </button>
                </div>
            </div>
        </div>


      <div>
        <b-modal
            id="modal-1"
            :title="$t('Verzenden als bestelling')"
            v-model="modalShowForm"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
            hide-footer
        >
          <form ref="form" @submit.stop.prevent="handleOk">
            <b-row>
              <b-col md="6">
                <!-- first name -->
                <b-form-group
                    :label="$t('Voornaam')"
                    label-for="input-firstname"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-firstname"
                      v-model="firstName"
                      :placeholder="$t('Voornaam')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- last name -->
                <b-form-group
                    :label="$t('Familienaam')"
                    label-for="input-lastname"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-lastname"
                      v-model="lastname"
                      :placeholder="$t('Familienaam')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- email -->
                <b-form-group
                    :label="$t('Email')"
                    label-for="input-email"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-email"
                      v-model="email"
                      type="email"
                      :placeholder="$t('Email')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- phone -->
                <b-form-group
                    :label="$t('Phone')"
                    label-for="input-phone"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-phone"
                      v-model="phone"
                      :placeholder="$t('Phone')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- reference -->
                <b-form-group
                    :label="$t('Reference')"
                    label-for="input-reference"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-reference"
                      v-model="reference"
                      :placeholder="$t('Reference')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- project -->
                <b-form-group
                    :label="$t('Project')"
                    label-for="input-project"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-project"
                      v-model="project"
                      :placeholder="$t('Project')"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">

                <!-- company -->
                <b-form-group
                    :label="$t('Bedrijf')"
                    label-for="input-company"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-company"
                      v-model="company"
                      :placeholder="$t('Bedrijf')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- VAT -->
                <b-form-group
                    :label="$t('BTW')"
                    label-for="input-vat"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-vat"
                      v-model="vat"
                      :placeholder="$t('BTW')"
                      required
                  ></b-form-input>
                </b-form-group>

                <!-- address -->
                <b-form-group
                    :label="$t('Straat en huisnummer')"
                    label-for="input-address"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-address"
                      v-model="address"
                      :placeholder="$t('Straat en huisnummer')"
                      required
                  ></b-form-input>
                </b-form-group>
                <b-row>
                  <!-- zip code -->
                  <b-col cols="4">
                    <b-form-group
                        :label="$t('Postcode')"
                        label-for="input-zip-code"
                        :invalid-feedback="$t('Verplicht veld')"
                    >
                      <b-form-input
                          id="input-zip-code"
                          v-model="zipCode"
                          :placeholder="$t('Postcode')"
                          required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <!-- city -->
                  <b-col cols="8">
                    <b-form-group
                        :label="$t('Stad')"
                        label-for="input-city"
                        :invalid-feedback="$t('Verplicht veld')"
                    >
                      <b-form-input
                          id="input-city"
                          v-model="city"
                          :placeholder="$t('Stad')"
                          required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Land -->
                <b-form-group
                    :label="$t('Land')"
                    label-for="input-country"
                    :invalid-feedback="$t('Verplicht veld')"
                >
                  <b-form-input
                      id="input-country"
                      v-model="country"
                      :placeholder="$t('Land')"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button type="submit" class="btn primary icon send" block >{{ $t('Verzenden als bestelling') }}</b-button>
            <b-button class="btn default icon closing mt-3" block @click="$bvModal.hide('modal-1')">{{ $t('Sluit') }}</b-button>

          </form>
        </b-modal>
      </div>


        <div class="table-responsive-lg">
            <table class="table">
                <tr>
                    <th>{{ $t('Type Klep') }}</th>
                    <th>{{ $t('Mechanisme')}} - {{ $t('Opties')}} - {{ $t('Kaders')}}</th>
                    <th>{{ $t('Eenheidsprijs') }}</th>
                    <th>{{ $t('Aantal') }}</th>
                    <th>{{ $t('Totaal') }}</th>
                </tr>
                <template v-for="product in Products">
                    <tr>
                        <td class="type">
                            <img :src="product.StepOne.productImgSrc" />
                            <span class="text">{{product.StepOne.sku}}</span>
                            <div class="buttons">
                                <button class="btn secondary icon edit small"></button>
                                <button class="btn grey icon remove small" @click="deleteConf(product.StepOne.id)"></button>
                            </div>

                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td v-if="product.StepOne.price">€{{product.StepOne.price}}</td>
                        <td class="number">
                            <button @click="product.Amount--" class="btn secondary icon minus small" :disabled="product.Amount <= 1"></button>
                            <input type="number" v-model="product.Amount" :min="1" />
                            <button @click="product.Amount++" class="btn secondary icon add small"></button>
                        </td>
                        <td>€{{subTotal(product)}}</td>
                    </tr>

                    <tr v-for="mechanism in product.StepTwo">
                        <!-- ml: don't show the mechanism itself, only the final variant-->
                        <template v-if="mechanism.type !== 'mechanisme'">
                            <td>&nbsp;</td>
                            <td>
                                <img :src="mechanism.imgSrc" />
                                <span class="text textbetween" v-if="mechanism.mectype !== undefined">{{mechanism.mectype}}&nbsp;{{mechanism.mectrans[$i18n.locale]}}</span>
                                <span class="text textbetween" v-if="mechanism.code !== undefined">{{mechanism.code}}&nbsp;{{mechanism.mectrans[$i18n.locale]}}</span>
                            </td>
                            <td v-if="mechanism.price">€{{mechanism.price}}</td>
                            <td>
                                &nbsp;
                            </td>
                            <td>
                                &nbsp;
                            </td>

                        </template>
                    </tr>

                    <tr v-for="option in product.StepThree">
                        <td>
                            <!--<input type="text" v-model="ammount[option.name]" value="1" />-->
                        </td>
                        <td>
                            <img :src="option.imgSrc" />
                            <span class="text" v-if="option.type === 'optie'">{{option.name}}</span>
                            <span class="text" v-else>{{option.value.info[$i18n.locale]}}</span>
                            <div class="buttons">
                                <!--                            <button class="btn secondary icon add small"></button>
                                                            <button class="btn secondary icon edit small"></button>
                                                            <button class="btn grey icon remove small"></button>-->
                            </div>
                        </td>
                        <td>€{{option.price}}</td>
                        <td>
                            &nbsp;
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-0" colspan="">&nbsp;</td>
                    </tr>
                    <!--                <tr>
                                        <td class="border-0">
                                            <span class="text">product total</span>
                                        </td>
                                        <td style="padding:0 !important;" colspan="4" class="border-0">€{{confTotal(product)}}</td>
                                    </tr>-->
                </template>
                <tr class="last-one">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ $t('Totaal')}}</td>
                    <td>€{{totalOrder}}</td>
                </tr>
                <tfoot>
                    <tr>
                      <td colspan="5" class="border-0 font-weight-normal">{{ $t('prijs_informatie')}}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="border-0 font-weight-normal py-0">{{ $t('prijs_informatie2')}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="bottom-info">
            <div class="block">
                <p>{{ $t('Voeg een nieuwe configuratie toe') }}</p>

                <div>
                    <button class="btn primary icon add" @click="newConf('brandNew')">{{ $t('Nieuwe configuratie') }}</button>
                </div>
            </div>

            <div class="block">
                <p>{{ $t('Of baseer die op uw vorige configuratie') }}:</p>
                <div>
                    <button @click="newConf('sameProductNewMec')" class="btn primary-inversed icon add" v-if="lastProductTxt">{{ $t('Zelfde product') }} ({{lastProductTxt}}) / {{ $t('Nieuw mechanisme') }}</button>
                </div>
              <div>
                <button @click="newConf('sameProductNewMeasures')" class="btn primary-inversed icon add" v-if="lastProductTxt">{{ $t('Zelfde product') }} ({{lastProductTxt}}) / {{ $t('Andere afmetingen')}}</button>
              </div>
                <div>
                    <button @click="newConf('NewProductSameMec')" class="btn primary-inversed icon add">{{ $t('Nieuw product') }} / {{ $t('zelfde mechanisme') }} ({{lastMecTxt}})</button>
                </div>
                <div>
                    <button @click="newConf('sameProductAndMecNewOptions')" class="btn primary-inversed icon add">{{ $t('Zelfde product') }} ({{lastProductTxt}}) / {{ $t('zelfde mechanisme') }} ({{lastMecTxt}}) / {{ $t('Nieuwe opties en kaders') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {EventBus} from '../services/eventBus'
import apiService from '../services/request'
import ToastAlert from '../components/elements/ToastAlert'

export default {
        data() {
            return {
                StepOne: '',
                StepTwo: [],
                StepThree: [],
                Products: [],
                Product: {},
                ammount: [],
                totalProducts: [],
                totalOrderWithAmount: 0,
                lastProductTxt: '',
                lastMecTxt: '',
                lastProductId: 0,
                isLoading: false,

                modalShowForm: false,

                firstName: '',
                lastname: '',
                company: '',
                email: '',
                phone: '',
                reference: '',
                project: '',
                vat: '',
                address: '',
                zipCode: '',
                city: '',
                country: '',
            };
        },
        name: "StepFour",
        methods: {
            resetModal() {
              this.firstName = ''
              this.lastname = ''
              this.company = ''
              this.email = ''
              this.phone = ''
              this.reference = ''
              this.project = ''
            },
            handleOk(bvModalEvent) {
              // Prevent modal from closing
              bvModalEvent.preventDefault()
              // Trigger submit handler
              this.sendAsOrder()
              this.modalShowForm = false
            },
            showForm () {
              this.modalShowForm = true
            },

            deleteConf (confId) {
                let result = confirm(this.$t("Bent u zeker dat u deze configuratie wilt verwijderen?"));
                if (result == true) {
                    if (this.Products !== null) { //  if there is products
                        for (let key in this.Products) {
                            if (this.Products[key].StepOne.id == confId) { // remove products from memory
                                this.Products.splice(key, 1)
                                Vue.ls.set("ProductsInMemory", JSON.stringify(this.Products))
                            }
                            if (this.Product.StepOne.id == confId) { //remove last added product
                                Vue.ls.remove('StepOne')
                                Vue.ls.remove('StepTwo')
                                Vue.ls.remove('StepThree')
                            }
                        }
                        if (!this.Products.length) { // clear all variables if there is no more configurations
                            Vue.ls.clear()
                        }
                    }
                }
            },
            newConf (typeConf) {
                switch (typeConf) {
                    case 'brandNew':
                        Vue.ls.remove('StepOne')
                        Vue.ls.remove('StepTwo')
                        Vue.ls.remove('StepThree')
                        this.$router.push({name: 'StepOne', query: {lang: this.$i18n.locale}})
                        break;
                    case 'sameProductNewMec':
                        Vue.ls.remove('StepTwo')
                        Vue.ls.remove('StepThree')
                        this.$router.push({name: 'StepTwo', query: { 'sameproduct': true , lang: this.$i18n.locale}})
                        break;
                    case 'sameProductNewMeasures':
                      Vue.ls.remove('StepOne')
                      Vue.ls.remove('StepTwo')
                      Vue.ls.remove('StepThree')
                      this.$router.push({name: 'StepOne', params:{} , query: {'sameproductnewmeasures': true, 'productId': this.Products[this.Products.length -1].StepOne.productId,  lang: this.$i18n.locale}})
                      break;
                    case 'NewProductSameMec':
                        Vue.ls.remove('StepOne')
                        Vue.ls.remove('StepThree')
                        this.$router.push({name: 'StepOne', query: { 'newproductsamemec': true , lang: this.$i18n.locale}})
                        break;
                    case 'sameProductAndMecNewOptions':
                        //samemec
                        Vue.ls.remove('StepThree')
                        this.$router.push({name: 'StepOne', query: { 'samemec': true , lang: this.$i18n.locale }})
                        break;
                }

            },
            sendExcelData () {
                let currentData = this.Products
                let vm = this
                let currentLang = vm.$i18n.locale
                if (currentData !== null) {

                    for (let keyProduct in this.Products) {
                        currentData[keyProduct].Subtotal = this.subTotal(currentData[keyProduct])
                    }
                }
                let total = Vue.ls.get('totalOrder')
                apiService.sendExcelData(currentData, currentLang, total)
            },
            sendPdfData () {
                let vm = this
                this.isLoading = true
                let currentLang = vm.$i18n.locale
                let currentData = this.Products

                if (currentData !== null) {

                    for (let keyProduct in this.Products) {
                        currentData[keyProduct].Subtotal = this.subTotal(currentData[keyProduct])
                    }
                }

                let total = Vue.ls.get('totalOrder')
                apiService.sendPdfData(currentData, currentLang, total, (data) => {
                    this.isLoading = false
                    let link = data;

                    window.open(link, '_blank')
                })
            },
            sendAsOrder () {
                let vm = this
                this.isLoading = true
                let currentLang = vm.$i18n.locale
                let currentData = this.Products

                if (currentData !== null) {

                  for (let keyProduct in this.Products) {
                    currentData[keyProduct].Subtotal = this.subTotal(currentData[keyProduct])
                  }
                }

                let total = Vue.ls.get('totalOrder')

                let orderData = {
                    address: this.address,
                    zipCode: this.zipCode,
                    city: this.city,
                    country: this.country,
                    vat: this.vat,
                    company: this.company,
                    firstName: this.firstName,
                    lastName: this.lastname,
                    email: this.email,
                    phone: this.phone,
                    reference: this.reference,
                    project: this.project,
                }

                apiService.sendOrderData(currentData, orderData, currentLang, total, (data) => {
                  this.isLoading = false

                  this.$toast.success({
                    component: ToastAlert,
                    props: {
                      pdfUrl: data,
                      text: this.$t("De offerteaanvraag is naar de afdeling quotation gestuurd."),
                      buttonText: this.$t("Klik hier om de pdf te bekijken."),
                    }
                  }, {
                    position: "bottom-right",
                    closeOnClick: false,
                    timeout: false,
                    closeButton: "button",
                  });
                })
            },
            deleteEverything () {
                let result = confirm(this.$t("Bent u zeker dat u wilt alles verwijderen?"));
                if (result == true) {
                    Vue.ls.clear()
                    location.reload()
                }
            },
            getExcel(response) {
                console.log(response)
            },
            multiplier(amount, value) {
                if(amount === undefined) {
                    amount = 1
                }

                return Math.round((value * amount) * 1e12) / 1e12
            },
            subTotal(obj) {
                let amount = 1
                if(obj.Amount !== undefined && obj.Amount >= 1) {
                    amount = obj.Amount
                }
                let productInMemory = obj
                let stepOne = 0
                let stepTwo = 0
                let stepThree = 0
                if (productInMemory.Amount >= 1) {
                  amount = productInMemory.Amount
                } else {
                  amount = 1
                }
                stepOne = Math.round(((productInMemory.StepOne.price) * amount) * 1e12) / 1e12
                for (var key in productInMemory.StepTwo) {
                    if(typeof(productInMemory.StepTwo[key].price) !== "undefined" && productInMemory.StepTwo[key].price !== null) {
                        let price = productInMemory.StepTwo[key].price

                        let priceWithAmount =  Math.round((price * amount) * 1e12) / 1e12
                        //productInMemory[keyProduct].StepTwo[key].price = priceWithAmount
                        stepTwo += Math.round((priceWithAmount) * 1e12) / 1e12
                    }
                }
                for (let key in productInMemory.StepThree) {
                    let price = productInMemory.StepThree[key].price
                    let priceWithAmount =  Math.round((price * amount) * 1e12) / 1e12
                    stepThree += Math.round((priceWithAmount) * 1e12) / 1e12
                }

                //console.log(stepTwo)
                let totals = Math.round((stepOne + stepTwo + stepThree) * 1e12) / 1e12;

                return totals.toFixed(2)
            },
            getTotal() {
                let totals = 0

                if (this.Products !== null) {
                    let productInMemory = this.Products
                    for (let keyProduct in productInMemory) {
                        let stepOne = 0
                        let stepTwo = 0
                        let stepThree = 0
                        let amount = 0
                        if (productInMemory[keyProduct].Amount >= 1) {
                          amount = productInMemory[keyProduct].Amount
                        } else {
                          amount = 1
                        }
                        stepOne = Math.round(((productInMemory[keyProduct].StepOne.price) * amount) * 1e12) / 1e12
                        for (var key in productInMemory[keyProduct].StepTwo) {
                            if(typeof(productInMemory[keyProduct].StepTwo[key].price) !== "undefined" && productInMemory[keyProduct].StepTwo[key].price !== null) {
                                let price = productInMemory[keyProduct].StepTwo[key].price
                                let priceWithAmount =  Math.round((price * amount) * 1e12) / 1e12
                                //productInMemory[keyProduct].StepTwo[key].price = priceWithAmount
                                stepTwo += Math.round((priceWithAmount) * 1e12) / 1e12

                            }
                        }

                        for (let key in productInMemory[keyProduct].StepThree) {
                            let price = productInMemory[keyProduct].StepThree[key].price
                            let priceWithAmount =  Math.round((price * amount) * 1e12) / 1e12
                            stepThree += Math.round((priceWithAmount) * 1e12) / 1e12
                        }

                        //console.log(stepTwo)
                        totals += Math.round((stepOne + stepTwo + stepThree) * 1e12) / 1e12;

                    }
                }

                Vue.ls.set('totalOrder', totals.toFixed(2))
                return totals.toFixed(2)

            },
        },
        mounted() {

            if (Vue.ls.get('ProductsInMemory') !== null) {
                this.Products = JSON.parse(Vue.ls.get("ProductsInMemory"))
            }
            if (!this.Products.length) { // Check if there is no products in memory
                /*if(Vue.ls.get('StepThree') === null) {
                    this.$router.push({name: 'StepThree'})
                }*/
                if(Vue.ls.get('StepTwo') === null) {
                    this.$router.push({name: 'StepTwo'})
                }
                if(Vue.ls.get('StepOne') === null) {
                    this.$router.push({name: 'StepOne'})
                }
            }

            EventBus.$emit('routeChange')
            this.StepOne = Vue.ls.get('StepOne')
            this.StepTwo = Vue.ls.get('StepTwo')
            this.StepThree = Vue.ls.get('StepThree')
            let lengthProduct = 0;
            if(this.StepThree !== null && typeof(this.StepThree.length) !== "undefined") {
                lengthProduct += this.StepThree.length
            }

            if(this.StepTwo !== null && typeof(this.StepTwo.length) !== "undefined") {
                lengthProduct += this.StepTwo.length + 1
            }
            this.Product = {
                StepOne: this.StepOne,
                StepTwo: this.StepTwo,
                StepThree: this.StepThree,
                Length:lengthProduct,
                Amount: 1,
                Subtotal: 0
            }

            let currentProductsIds = []
            if (this.Products.length) {
                for (let keyProduct in this.Products) {
                    currentProductsIds[this.Products[keyProduct].StepOne['id']] = this.Products[keyProduct].StepOne['id']
                }
                let existAlreadyInCart = false
                for (let keyCurentsId in currentProductsIds) {
                    let cameFromNewMec = false
                    let fromNewConf = Vue.ls.get("newConf")
                    if (fromNewConf !== null) {
                        if (fromNewConf) {
                            cameFromNewMec = true
                        }
                    }
                    if (this.Product.StepOne['id'] == keyCurentsId && !cameFromNewMec) {
                        existAlreadyInCart = true
                        break
                    }
                }
                if (!existAlreadyInCart && this.Product !== null) {
                    this.Products.push(this.Product)
                }
                Vue.ls.set("newConf", false)
            } else {
                this.Products.push(this.Product)
            }
            if (this.Products[this.Products.length -1] !== undefined) {
                if (typeof(this.Products[this.Products.length -1].StepOne.sku) !== "undefined" && this.Products[this.Products.length -1].StepOne.sku !== null) {
                    this.lastProductTxt = this.Products[this.Products.length -1].StepOne.sku
                }

                if (typeof(this.Products[this.Products.length -1].StepTwo.mechanisme.name) !== "undefined" && this.Products[this.Products.length -1].StepTwo.mechanisme.name !== null) {
                    this.lastMecTxt = this.Products[this.Products.length -1].StepTwo.mechanisme.name
                }

            }
        },
        computed: {
            totalOrder: function () {
                if (this.Products.length) {
                    Vue.ls.set("ProductsInMemory", JSON.stringify(this.Products))
                    return parseFloat(this.getTotal()).toFixed(2)
                }
                return 0
            }
        },
        watch: {
            Products: {
                handler(newVal) {
                  newVal.forEach(product => {
                    if (product.Amount < 1) {
                      product.Amount = 1
                    }
                  })
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/StepFour.vue